/**
 * Project client
 *
 * Created by stefensuhat on 01/09/18 1.46 PM
 */

import get from 'lodash/get';
import React from 'react';
import PropTypes from 'prop-types';
import { TextField as TF } from '@material-ui/core';

const propTypes = {
    errors: PropTypes.object,
    name: PropTypes.string.isRequired,
};
const defaultProps = { errors: {} };

function TextField({ name, errors, helperText, ...props }) {
    return (
        <TF
            {...props}
            name={name}
            error={!!errors[name]}
            helperText={helperText || get(errors, `${name}.message`)}
        />
    );
}

TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export default TextField;
